import makeHttpRequest from "./makeHttpRequest";

// Ответ приходит блобом, поэтому ошибка сервера тоже блоб: без разбора
// пользователь не получал ни файла, ни причины отказа
const readErrorMessage = async (blob) => {
    if (!(blob instanceof Blob)) return null;

    try {
        const payload = JSON.parse(await blob.text());

        return payload.message || payload.error || null;
    } catch {
        return null;
    }
};

export const downloadFile = async (url, fileName, params) => {
    let response;

    try {
        response = await makeHttpRequest({
            url,
            method: "GET",
            params,
            responseType: "blob",
        });
    } catch (error) {
        const message = await readErrorMessage(error.response?.data);

        throw message ? new Error(message) : error;
    }

    if (response.data?.type?.includes("application/json")) {
        const message = await readErrorMessage(response.data);

        throw new Error(message || "Файл не сформирован");
    }

    const href = URL.createObjectURL(response.data);

    const anchorElement = document.createElement("a");

    anchorElement.href = href;
    anchorElement.download = fileName;

    document.body.appendChild(anchorElement);
    anchorElement.click();

    document.body.removeChild(anchorElement);
    URL.revokeObjectURL(href);
};
